export default __webpack_public_path__ + "static/media/phone_green.5d2b0782.svg";